import tr from "@/utils/Tr";

export const brandingVideosGuides = () => [
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Quick-Guide-branding-1.png",
        imageAlt: "How to generate branding or cash labels video",
        imageLink: "https://youtu.be/r_7DI86TxPU",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Data-1.png",
        imageAlt: "Where to manage label templates in the system",
        imageLink: "https://youtu.be/KoLreMroSoE",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Adding-Branding-to-a-single-product.png",
        imageAlt: "Adding branding elements to a single product",
        imageLink: "https://youtu.be/5P1GqF8o4Ps",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Frame-1550.png",
        imageAlt: "Adding branding elements to an entire product category video",
        imageLink: "https://youtu.be/rSZo2Ljtl6U",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Logo-1.png",
        imageAlt: "How to add your logo to the system, which will later appear on tags",
        imageLink: "https://youtu.be/5OqnarcBE9E",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Frame-1564.png",
        imageAlt: "Changing Name and Marketing Name",
        imageLink: "https://youtu.be/zMuSXS3ST0Y",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Address-1.png",
        imageAlt: "Changing Address Information on WCL Sticker",
        imageLink: "https://youtu.be/WbzfcNbUt58",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Frame-1546-1.png",
        imageAlt: "Changing Material Composition on WCL",
        imageLink: "https://youtu.be/5RbwFsSm-9U",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Wash-and-Care-1.png",
        imageAlt: "Changing Graphic Symbols for Wash and Care Instructions",
        imageLink: "https://youtu.be/-l7dRNAfbns",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Size-1.png",
        imageAlt: "Changing Size Markings on WCL",
        imageLink: "https://youtu.be/yO5trQHZOLk",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Price-1.png",
        imageAlt: "Changing price on Price Sticker",
        imageLink: "https://youtu.be/GWp1G_eheSw",
    },
    {
        imageSrc: "https://silkplm.com/wp-content/uploads/2025/02/Order-template-1.png",
        imageAlt: "Ordering a customized template",
        imageLink: "https://youtu.be/L168PP_REw8",
    },
];